import { useLayoutEffect, useState } from 'react';

import { useLanguage } from '@/hooks/user';
import { showError } from '@/utils';

const messagesCache = {};

export function useStaticTexts(key) {
	const locale = useLanguage();
	const [messages, setMessages] = useState(messagesCache[locale] || {});

	useLayoutEffect(() => {
		if (messagesCache[locale]) {
			return setMessages(messagesCache[locale]);
		}

		import(`@/locales/legal-locales/${locale}.js`)
			.then(({ default: newMessages }) => {
				setMessages(newMessages);
				messagesCache[locale] = newMessages;
			})
			.catch(error => {
				showError(error);
			});
	}, [locale]);

	return messages[key] || '';
}
